export const customerServiceUrl =
  'https://arcosdourados.my.site.com/McDonaldsContacto/s/?language=es'
